<div class="grid-section">
  <div class="toolbar">
    <dx-button
      icon="plus"
      text="Dodaj novu"
      type="default"
      (onClick)="onAddClick()">
    </dx-button>
    
    <dx-button
      icon="edit"
      text="Izmijeni"
      type="default"
      [disabled]="!selectedJedinicaMjere"
      (onClick)="onEditClick()">
    </dx-button>
    
    <!-- <dx-button
      icon="trash"
      text="Delete"
      type="danger"
      [disabled]="!selectedJedinicaMjere"
      (onClick)="onDeleteClick()">
    </dx-button> -->
    
    <dx-button
      icon="refresh"
      text="Osvježi"
      type="default"
      (onClick)="loadJediniceMjere()">
    </dx-button>
  </div>

  <dx-data-grid
    #jediniceMjereGrid
    id="jediniceMjereGrid"
    keyExpr="id"
    [dataSource]="gridData"
    [showBorders]="true"
    [allowColumnResizing]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [hoverStateEnabled]="true"
    [filterRow]="{ visible: true }"
    [searchPanel]="{ visible: true }"
    [paging]="{ pageSize: 50 }"
    [pager]="{
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 50, 100],
      showInfo: true
    }"
    [selection]="{ mode: 'single' }"
    [rowAlternationEnabled]="true"
    (onRowClick)="onRowClick($event)">
    
    <dxi-column dataField="jedinica" caption="Jedinica Mjere" [minWidth]="200"></dxi-column>
    <!-- Add other columns based on your Jedinica_mjere model -->
    
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
  </dx-data-grid>
</div>

<!-- Create Popup -->
<dx-popup
  [width]="500"
  [showTitle]="true"
  title="Dodaj Novu Jedinicu Mjere"
  [(visible)]="isCreatePopupVisible"
  (onHiding)="onCreatePopupHidden()">
  
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="jedinicaMjereForm">
      <div class="form-fields">
        <dx-text-box
          formControlName="jedinica"
          placeholder="Unesite naziv jedinice mjere"
          [isValid]="!jedinicaMjereForm.get('jedinica')?.errors"
          validationMessage="Naziv jedinice mjere je obavezan">
        </dx-text-box>
        
        <!-- Add other form fields as needed -->
      </div>
      
      <div class="popup-buttons">
        <dx-button
          text="Kreiraj"
          type="default"
          (onClick)="createJedinicaMjere()"
          [disabled]="!jedinicaMjereForm.valid || loading">
        </dx-button>
        
        <dx-button
          text="Otkaži"
          (onClick)="isCreatePopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<!-- Edit Popup -->
<dx-popup
  [width]="500"
  [showTitle]="true"
  title="Izmijeni Jedinicu Mjere"
  [(visible)]="isEditPopupVisible"
  (onHiding)="onEditPopupHidden()">
  
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="jedinicaMjereForm">
      <div class="form-fields">
        <dx-text-box
          formControlName="jedinica"
          placeholder="Unesite naziv jedinice mjere"
          [isValid]="!jedinicaMjereForm.get('jedinica')?.errors"
          validationMessage="Naziv jedinice mjere je obavezan">
        </dx-text-box>
        
        <!-- Add other form fields as needed -->
      </div>
      
      <div class="popup-buttons">
        <dx-button
          text="Izmijeni"
          type="default"
          (onClick)="updateJedinicaMjere()"
          [disabled]="!jedinicaMjereForm.valid || loading">
        </dx-button>
        
        <dx-button
          text="Otkaži"
          (onClick)="isEditPopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<dx-load-panel
  [position]="loadPanelPosition"
  [visible]="loading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>